import { Immutable } from "immer";
import React from "react";
import { WistiaBackgroundVideo } from "tsi-common-react/src/components/WistiaBackgroundVideo/index";

import type { MegaHeroBlock as Value } from "@reactivated";

import { RichTextBlock } from "@thelabnyc/thelabui/src/components/RichText";

type Props = Immutable<{
    value: Value;
}>;

export const MegaHeroBlock = (props: Props): React.JSX.Element => {
    const v = props.value;
    const image = v.image;
    const link = v.link;
    // The legacy template's `{% include_block value.link %}` resolves the href
    // as `page.url` -> `external_url` -> `#`, adds `class="button"` when
    // `is_button`, and renders `display_name` as the link text.
    const linkHref = link?.page?.url ?? link?.external_url ?? "#";
    return (
        <>
            {/* The legacy template rendered the Wistia <figure> only when
                `value.video` was set. WistiaBackgroundVideo emits the exact
                same figure markup (the legacy `{% include_block %}` raw-text
                quirk is an unintended artifact, not reproduced here). */}
            {v.video && <WistiaBackgroundVideo videoId={v.video} />}
            {/* `{% image value.image original %}`: the block declares the
                `original` rendition, so read its URL directly. Dimensions come
                from the image's top-level width/height (same as the original
                rendition). Wagtail's `.alt` resolves to default alt text. */}
            {image && (
                <img
                    src={image.renditions["original"].url}
                    alt={image.default_alt_text}
                    width={image.width}
                    height={image.height}
                />
            )}
            {/* The explicit content <div> (no className) is load-bearing: the
                `.block-mega_hero > div` SCSS targets it, with `.rich-text` and
                `a` as descendants. Both rich_text and link live inside it. */}
            <div>
                <RichTextBlock value={v.rich_text ?? ""} />
                {link?.display_name && (
                    <a
                        href={linkHref}
                        className={link.is_button ? "button" : undefined}
                    >
                        {link.display_name}
                    </a>
                )}
            </div>
        </>
    );
};
